







































































































































































































































import { Vue, Component, Emit } from "vue-property-decorator";
// import { IdCardPaymentRequest } from '@fgl/funfangle-sdk/dist/rest/bank/payment/IdCardPaymentRequest';
import { User } from "@fgl/funfangle-sdk/dist/rest/profile";
import PaymentMethodSquare from '@/views/account/paymentmethods/square/SquarePayment.vue';
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { BankModule, NavModule, ProfileModule } from "@/store";
import ProfilePhoto from "@/components/profiles/ProfilePhotoComponent.vue";
import {
  mdbAlert,
  // mdbBtn,
  // mdbInput,
  mdbCol,
  mdbContainer,
  mdbRow,
  mdbSelect,
  mdbSpinner
} from "mdbvue";
import { v1 as uuidv1 } from 'uuid';
import { BankInvoiceApiClient } from "@/shared/api";
import { Invoice, InvoiceResponse } from "@fgl/funfangle-sdk/dist/rest/bank";
import { InvoicePaymentRequest } from "@fgl/funfangle-sdk/dist/rest/bank/payment";
import { RouterNames } from "@/router/RouterNames";

// Define the props by using Vue's canonical way.
const InvoiceProps = Vue.extend({
  props: {
    id: Number,
    showSkipBtn: {
      type: Boolean,
      default: false
    }
  }
});

@Component({
  components: {
    mdbAlert,
    mdbCol,
    mdbContainer,
    mdbRow,
    mdbSelect,
    mdbSpinner,
    PaymentMethodSquare,
    ProfilePhoto
  }
})
export default class InvoiceComponent extends InvoiceProps {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  activeSection = '#loading';
  isLoading: boolean = false;
  isProcessing: boolean = false;
  errorMessage: string | null = null;
  MQ = MQ;
  idempotent: string | null = null;
  paymentCheckNumber: string | null = null;
  paymentMethod: string | null = null;
  authUser: User | null = null;
  // orderType: string = 'New';
  participants: any[] = [];
  nonce: string | null = null;
  invoiceResponse: InvoiceResponse | null = null;

  get amountDue(): number {
    // const amount = this.orderType === 'Replacement' ? 25 : 0;
    // if (amount !== undefined) return amount;
    if (this.invoiceResponse != null && this.invoiceResponse !== undefined && this.invoiceResponse.data.code === 'OK' && this.invoiceResponse.data.item !== undefined) {
      return this.invoiceResponse.data.item.balanceDue || 0;
    }
    return 0.0
  }

  get amountDueVal(): string {
    return this.amountDue.toFixed(2);
  }

  get disableSubmit(): boolean {
    // if (this.selectedUser == null) return true;
    return false;
  }

  get hasCheckNumber(): boolean {
    return !(this.paymentCheckNumber == null || this.paymentCheckNumber === undefined || this.paymentCheckNumber === '');
  }

  get invoice(): Invoice | null {
    // const amount = this.orderType === 'Replacement' ? 25 : 0;
    // if (amount !== undefined) return amount;
    if (this.invoiceResponse != null && this.invoiceResponse !== undefined && this.invoiceResponse.data.code === 'OK' && this.invoiceResponse.data.item !== undefined) {
      return this.invoiceResponse.data.item;
    }
    return null
  }

  get isInitialized() {
    if (this.amountDue <= 0) return false;
    if (this.idempotent == null) return false;
    if (this.profileStore.organizationId == null || this.profileStore.organizationId === undefined) return false;
    if (this.profileStore.userId === undefined) return false;
    return true;
  }

  get showPaymentByCheck(): boolean {
    return true;
  }

  get showPaymentByCredit(): boolean {
    return false;
  }

  get showPaymentComingSoonElectronicPayments(): boolean {
    const orgId = this.profileStore.organizationId;
    if (orgId === '0b9c4c63-34a2-4361-9a62-27db40b8e0f0' || orgId === 'prod-dup-34a2-4361-9a62-27db40b8e0f0') {
      return true;
    }
    return false;
  }

  get showSubmitButton(): boolean {
    return (this.paymentMethod === 'check' && this.hasCheckNumber) || (this.paymentMethod === 'card' && this.amountDue > 0 && this.nonce != null);
  }

  // get isFormValid() {
  //   if (
  //     this.profileStore.currOrganization.customPaymentOptions !== undefined &&
  //     /[\S]+/.test(this.userRequest.memberId || "")
  //   ) {
  //     for (let paymentOption of this.profileStore.currOrganization
  //       .customPaymentOptions) {
  //       if (
  //         paymentOption.slug === "member" &&
  //         paymentOption.regex !== undefined
  //       ) {
  //         let re = new RegExp(paymentOption.regex);
  //         return re.test(this.userRequest.memberId || "");
  //       }
  //     }
  //   }
  //   return /[\S]+/.test(this.userRequest.memberId || "");
  // }

  mounted() {
    if (this.$route.params.invoiceId === undefined) {
      this.$router.push({ name: RouterNames.INVOICE_LIST });
      return;
    }
    this.reset();
  }

  goReturn() {
    this.$router.push({ name: RouterNames.INVOICE_LIST });
  }

  reset() {
    this.idempotent = uuidv1();
    this.isLoading = true;
    this.errorMessage = null;
    const api = new BankInvoiceApiClient();
    api.getInvoiceDetail(this.$route.params.invoiceId).then(rs => {
      this.invoiceResponse = rs;
      this.isLoading = false;
      if (rs.data.code !== 'OK' && rs.data.message !== undefined) {
        this.errorMessage = rs.data.message;
      }
      this.activeSection = '#form';
    }).catch((e) => {
      this.errorMessage = e.message;
      this.isLoading = false;
      this.activeSection = '#form';
    })
  }

  /** Return via the calling 'Next' button */
  @Emit('next')
  emitNext(e: any) {
    return e;
  }
  /** Handle the click event of the 'Next' button */
  async handlePostPaymentMethod(e: any) {
    this.nonce = e.nonce;
  }

  async handleCheckSubmit() {
    this.errorMessage = null;

    if (this.idempotent == null) {
      this.errorMessage = 'idempotent is not set'; return;
    }
    if (this.profileStore.accountId === undefined) {
      this.errorMessage = 'AccountId is not set'; return;
    }
    if (this.profileStore.organizationId == null || this.profileStore.organizationId === undefined) {
      this.errorMessage = 'OrganizationId is not set'; return;
    }
    if (this.profileStore.userId === undefined) {
      this.errorMessage = 'UserId is not set'; return;
    }
    if (this.$route.params.invoiceId === undefined) {
      this.errorMessage = 'InvoiceId is not set'; return;
    }

    const request = new InvoicePaymentRequest(
      this.amountDue,
      this.profileStore.accountId,
      this.idempotent,
      this.$route.params.invoiceId,
      this.profileStore.organizationId,
      this.profileStore.userId,
    );
    request.amountType = 'DECIMAL';
    request.checkNumber = this.paymentCheckNumber || undefined;
    request.paymentStatus = 'incomplete';

    this.isProcessing = true;
    const svc = new BankInvoiceApiClient();
    svc.postInvoiceCheckPayment(request).then(rs => {
      if (rs.data.code !== 'OK') {
        this.errorMessage = rs.data.message || `An error has occurred: ${rs.data.code}`;
      } else {
        this.invoiceResponse = rs;
      }
      this.isProcessing = false;
      this.activeSection = '#success';
    }).catch(e => {
      this.isProcessing = false;
      this.errorMessage = e.message;
    })
  }

  async handleSquareSubmit() {
    // console.log('handleChargeCallback', e);
    this.errorMessage = null;
    this.isProcessing = true;
    let hasError = false;

    if (this.idempotent == null) return;

    // if (this.authUserId === undefined) {
    //   this.errorMessage = 'Please selected a participant from the dropdown';
    //   return;
    // }
    // if (this.orderType === undefined) {
    //   this.errorMessage = 'Please select whether this is a new or replacement card';
    //   return;
    // }
    // if (this.imageUrl === undefined || this.imageUrl === '/img/campers/default.png') {
    //   this.errorMessage = 'Please click on the silhouette above to upload an image';
    //   return;
    // }
    if ((this.nonce === null || this.nonce === undefined) && this.amountDue > 0) {
      this.errorMessage = 'Card card not captured correctly';
      return;
    }
    if (this.nonce === null || this.nonce === undefined) {
      this.nonce = 'NA';
    }

    // const req = new IdCardPaymentRequest(Math.round(this.amountDue * 100), this.authUserId, this.idempotent, this.imageUrl, this.nonce, this.profileStore.organizationId || 'UNSET', this.profileStore.userId || 'UNSET', 'DECIMAL');
    // // req.orderType = this.orderType;

    // const url = `${ApiEndpoints.apiEndpoint}/v2/bank/payment/idcard/square`;
    // // console.log('idcard submit', url, req);
    // const res = await apiSvc.httpPost(url, req).catch(err => {
    //   this.errorMessage = err.message;
    //   hasError = true;
    // });
    this.isProcessing = false;
    // console.log('idcard payment res', hasError, res);
    if (hasError) return;
    // if (!res || !res.data || res.data === undefined) {
    //   this.errorMessage = 'Server did not respond. Please reload the page to try again.'
    //   return
    // };
    // if (res.data.code === 'Error') {
    //   this.errorMessage = res.data.message || 'Indeterminate error occurred';
    //   this.reset();
    //   return;
    // }
    // if (res.data.code === 'OK' && res.data.item !== undefined && res.data.item.status === 'error') {
    //   const util = new SquareUtils();
    //   const msg = util.formatErrorMessage(res.data.item.processorErrorName);

    //   if (msg !== undefined) {
    //     this.errorMessage = `${msg}. Please check and retry`;
    //   } else {
    //     this.errorMessage = res.data.item.processorErrorMessage || res.data.item.paymentNotes || 'Indeterminate error occurred';
    //   }
    //   this.reset();
    //   return;
    // }
    this.activeSection = '#success';
    // emit to parent that the 'next' event happened
    await this.profileStore.fetchUserDetails();
    // this.emitNext();
  }

  /** Handle the click event of the 'Skip' button */
  @Emit('skip')
  handleSkip(e: any) {
    // emit to parent that the 'skip' event happened
    return e;
  }
}
